import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "container", "orderInput"]
  static values = {
    type: { type: String, default: "photos" }
  }

  connect() {
    this.draggedItem = null
    this.setupDragAndDrop()
    this.updateMainBadge()
  }

  setupDragAndDrop() {
    this.itemTargets.forEach(item => {
      item.setAttribute("draggable", true)
      item.classList.add("cursor-move")
    })
  }

  dragStart(event) {
    this.draggedItem = event.target.closest("[data-sortable-photos-target='item']")
    if (!this.draggedItem) return

    this.draggedItem.classList.add("opacity-50", "ring-2", "ring-teal-500")
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", "")
  }

  dragEnd(event) {
    if (this.draggedItem) {
      this.draggedItem.classList.remove("opacity-50", "ring-2", "ring-teal-500")
    }
    this.draggedItem = null
  }

  dragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    const target = event.target.closest("[data-sortable-photos-target='item']")
    if (!target || target === this.draggedItem || !this.draggedItem) return

    const container = this.containerTarget
    const items = [...container.querySelectorAll("[data-sortable-photos-target='item']")]
    const targetIndex = items.indexOf(target)
    const draggedIndex = items.indexOf(this.draggedItem)

    if (targetIndex > draggedIndex) {
      target.parentNode.insertBefore(this.draggedItem, target.nextSibling)
    } else {
      target.parentNode.insertBefore(this.draggedItem, target)
    }
  }

  drop(event) {
    event.preventDefault()
    this.updateOrder()
    this.updateMainBadge()
  }

  updateOrder() {
    const items = this.containerTarget.querySelectorAll("[data-sortable-photos-target='item']")
    const order = [...items].map(item => item.dataset.blobId).filter(id => id)

    // Update hidden input with the new order
    if (this.hasOrderInputTarget) {
      this.orderInputTarget.value = JSON.stringify(order)
    }
  }

  updateMainBadge() {
    // Remove main badge from all items
    this.itemTargets.forEach(item => {
      const badge = item.querySelector("[data-main-badge]")
      if (badge) {
        badge.classList.add("hidden")
      }
    })

    // Add main badge to first item
    const firstItem = this.itemTargets[0]
    if (firstItem) {
      const badge = firstItem.querySelector("[data-main-badge]")
      if (badge) {
        badge.classList.remove("hidden")
      }
    }
  }
}
